export default [
 { title: 'Quienes Somos', to: '#!' },
 { title: 'Contáctenos', to: '#!' },
 { title: 'Profesionales', to: '#!' },
 { title: 'Blog', to: '#!' },
 { title: 'Términos', to: '/privacy-policy2' },
 { title: 'Politicas de Privacidad', to: '/privacy-policy2' },
 { title: 'Imprimir', to: '#!' }
];
